import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IReduxAppState } from '../../../../../reducers';

import Styles from './styles.module.scss';

interface IProps {
    totalValue: string;
    selection: string;
    loading?: boolean;
    onCategoryChange: (value: string) => void;
    categories: { id: string; name: string }[];
}

const CategorySummaryTotals = (props: IProps) => {
    const venueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const venueData = useSelector((state: IReduxAppState) => state.venue[venueId]?.venueData);
    const isSquare = venueData?.payment_processor === 'SQUARE';
    const { t } = useTranslation();

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        props.onCategoryChange(event.target.value as string);
    };
    const renderCategories = () => {
        //@TODO - not a good solution, backend should handle this
        const filteredCategories = isSquare
            ? props.categories?.filter((cat) => cat.name === 'MENU')
            : props.categories?.filter((cat) => cat.name !== 'MENU' && cat.name !== 'MAIN');
        return filteredCategories.map((category) => {
            return (
                <option value={category.id}>
                    {isSquare ? category.name : t(`dashboard.category.${category.name}`)}
                </option>
            );
        });
    };

    return (
        <div className={Styles.Totals}>
            <div className={Styles.TotalTitle}>{t('dashboard.totalSales', { type: props.selection })}</div>
            {props.categories && props.categories.length > 1 ? (
                <select className={Styles.DropDown} value={props.selection} onChange={handleChange}>
                    {renderCategories()}
                </select>
            ) : null}

            <div className={Styles.TotalValue}>{props.totalValue}</div>
        </div>
    );
};

export default CategorySummaryTotals;
